import actions from './error/actions';
import reducer from './error/reducer';

export {
  actions,
  reducer,
};
